import ToolsPickaxe from '@streamlinehq/streamlinehq/img/streamline-light/tools-constructions/tools/tools-pickaxe.svg';
import { StatusBarItem, StatusBarTextAndIcon } from '../../shared';

interface Props {
  onClick: () => void;
  toolsVisible: boolean;
}

export function InternalToolsItem(props: Props) {
  // const text = props.toolsVisible ? 'Hide internal toolbar' : 'Show internal toolbar';
  const text = 'Internal tools';

  return (
    <StatusBarItem onClick={() => props.onClick()}>
      <StatusBarTextAndIcon text={text} slIcon={<ToolsPickaxe />} />
    </StatusBarItem>
  );
}
